import * as React from 'react';
import { Classes, IProps, Link } from '../index';
import classNames from 'classnames';
import { LinkProps } from 'react-router-dom';

export interface IDBreadcrumbProps extends IProps {
  /**
   * Obsah/popisek komponenty
   */
  label: React.ReactNode;
  /**
   * Odkaz k přesměrování při kliknutí
   */
  link?: LinkProps;
  /**
   * Akce při kliknutí
   */
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

/**
 * Breadcrumb - komponenta pro navigaci mezi stránkama.
 */
export const Breadcrumb: React.FC<IDBreadcrumbProps> = ({
  label,
  link,
  className,
  onClick,
  ...other
}) => {
  return (
    <>
      {link ? (
        <Link {...link}>
          <div
            className={classNames(
              Classes.BREADCRUMB,
              Classes.BREADCRUMB_INTERACTIVE,
              className
            )}
            {...other}
          >
            {label}
          </div>
        </Link>
      ) : (
        <div
          className={classNames(
            Classes.BREADCRUMB,
            { [Classes.BREADCRUMB_INTERACTIVE]: onClick },
            className
          )}
          onClick={onClick}
          tabIndex={onClick && 0}
          {...other}
        >
          {label}
        </div>
      )}
    </>
  );
};
